export const VIDEO_SOURCE_TYPES = {
    twentyThree: 'twentyThree',
    twentyThreeEmbedded: 'twentyThreeEmbedded',
    storyblok: 'storyblok',
    youtubeEmbedded: 'youtubeEmbedded',
    genericEmbedded: 'genericEmbedded',
} as const;
export type VideoSource = keyof typeof VIDEO_SOURCE_TYPES;

// Group for embedded sources
export const EMBEDDED_VIDEO_SOURCES: VideoSource[] = ['twentyThreeEmbedded', 'youtubeEmbedded', 'genericEmbedded'];

export function isEmbeddedVideoSource(source: VideoSource): boolean {
    return EMBEDDED_VIDEO_SOURCES.includes(source);
}
